"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var hal_rest_client_1 = require("hal-rest-client");
var universal_url_1 = require("universal-url");
var XtvapiResource = /** @class */ (function () {
    // protected xForms:
    function XtvapiResource(rawResource, baseUri, isDocRoot) {
        this.baseUri = baseUri;
        this.isDocRoot = isDocRoot;
        this.halResource = rawResource;
        this.relations = new Map();
        this.properties = new Map();
        this.buildPropRelations();
        this.buildLinkRelations();
        // When hal-rest-client fetches a link, it passes the base URL and the link URL to the Axios
        // HTTP client, which is not very smart and simply concatenates them together. This doesn't
        // work when the link URL is a relative URL containing, e.g., "../". Instead, we fully resolve
        // the URL up front so that an absolute URL is passed into Axios and it doesn't attempt
        // any resolution or concatenation.
        // It is also necessary to strip the '#' that is present in some XtvAPI tag URIs
        this.halResource.uri.uri = new universal_url_1.URL(this.halResource.uri.uri.replace(/^#/, ''), this.baseResolutionUri()).toString();
    }
    XtvapiResource.prototype.getBaseUri = function () {
        return this.baseUri;
    };
    XtvapiResource.prototype.getType = function () {
        return this.halResource.prop('_type');
    };
    XtvapiResource.prototype.getLinkUrl = function (link, params) {
        if (params === void 0) { params = {}; }
        var foundLink = this.halResource.link(link);
        var fetched = foundLink.uri.fetchedURI;
        if (fetched) {
            return fetched;
        }
        var filled = foundLink.uri.fill(params);
        if (filled.includes(this.baseUri)) {
            return filled;
        }
        // It is sometimes necessary to ensure the base URI is present in the filled URI,
        // such as in instances when a link is templated and its `uri.template` is used
        // but does not include the baseUri.
        return this.baseUri + "/" + filled;
    };
    XtvapiResource.prototype.getUri = function () {
        if (this.halResource.uri.fetchedURI) {
            return this.halResource.uri.fetchedURI;
        }
        return this.halResource.uri.uri;
    };
    XtvapiResource.prototype.hasProp = function (propName) {
        return this.properties.get(propName);
    };
    XtvapiResource.prototype.getProp = function (propName) {
        return this.properties.get(propName);
    };
    XtvapiResource.prototype.hasRelation = function (relationName) {
        return this.relations.has(relationName);
    };
    XtvapiResource.prototype.fetchResources = function (relationName, params) {
        return __awaiter(this, void 0, void 0, function () {
            var relations, resources, i, relation, halResource, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        relations = this.relations.get(relationName);
                        if (relations === undefined) {
                            throw new Error("Relation " + relationName + " not found");
                        }
                        resources = [];
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < relations.length)) return [3 /*break*/, 5];
                        relation = relations[i];
                        if (!relation.halResource.isLoaded) return [3 /*break*/, 2];
                        resources.push(relation);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, relation.halResource.fetch(params)];
                    case 3:
                        halResource = _a.sent();
                        res = new XtvapiResource(halResource, this.getUri(), true);
                        relations[i] = res;
                        resources.push(res);
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/, resources];
                }
            });
        });
    };
    XtvapiResource.prototype.baseResolutionUri = function () {
        if (this.isDocRoot) {
            return this.halResource.uri.fetchedURI;
        }
        else {
            return this.baseUri;
        }
    };
    XtvapiResource.prototype.buildPropRelations = function () {
        var rawResource = this.halResource;
        for (var _i = 0, _a = Object.keys(rawResource.props); _i < _a.length; _i++) {
            var propName = _a[_i];
            var prop = rawResource.prop(propName);
            // property is a forms
            if (propName === '_forms') {
                // TODO
            }
            // property is single HalResource
            if (prop instanceof hal_rest_client_1.HalResource) {
                var res = new XtvapiResource(prop, this.baseResolutionUri(), false);
                this.relations.set(propName, [res]);
                continue;
            }
            // property houses a list of embeds that are HalResources
            if (prop instanceof Array && prop.length && prop[0] instanceof hal_rest_client_1.HalResource) {
                var resources = this.relations.get(propName) || [];
                for (var _b = 0, prop_1 = prop; _b < prop_1.length; _b++) {
                    var p = prop_1[_b];
                    var res = new XtvapiResource(p, this.baseResolutionUri(), false);
                    resources.push(res);
                    this.relations.set(propName, resources);
                }
                continue;
            }
            // property houses a list
            if (prop instanceof Array && prop.length && !(prop[0] instanceof hal_rest_client_1.HalResource)) {
                this.properties.set(propName, prop);
                continue;
            }
            this.properties.set(propName, prop);
        }
    };
    XtvapiResource.prototype.buildLinkRelations = function () {
        var rawResource = this.halResource;
        for (var _i = 0, _a = Object.keys(rawResource.links); _i < _a.length; _i++) {
            var linkName = _a[_i];
            var link = rawResource.link(linkName);
            if (link instanceof hal_rest_client_1.HalResource) {
                this.relations.set(linkName, [new XtvapiResource(link, this.baseResolutionUri(), false)]);
                continue;
            }
            if (link instanceof Array) {
                var resources = this.relations.get(linkName) || [];
                for (var _b = 0, link_1 = link; _b < link_1.length; _b++) {
                    var l = link_1[_b];
                    resources.push(new XtvapiResource(l, this.baseResolutionUri(), false));
                }
                this.relations.set(linkName, resources);
            }
        }
    };
    return XtvapiResource;
}());
exports.XtvapiResource = XtvapiResource;
//# sourceMappingURL=xtvapi-resource.js.map